<template>
  <layout title="Produtos" :options="options" :rotas="rotas">
    <v-sheet
      style="min-height: 100vh; max-height: 100vh; overflow: hidden;"
      :dark="$theme.dark"
      :light="$theme.light"
      class="expande-horizontal pt-3 wrap"
    >
      <v-flex xs12 class="pr-1" lg3>
        <Filtros
          v-model="filter"
          @input="updateList"
          :class="{ 'pl-0 ml-0': $vuetify.breakpoint.smAndUp }"
        />
        <v-flex v-if="get_insumos.docs.length > 0" xs12>
          <v-list
            class="pa-0 ma-0"
            dense
            :dark="$theme.dark"
            :light="$theme.light"
            background-color="transparent"
            style="min-height: 20vh; max-height: 90vh; overflow: auto;"
          >
            <span class="mx-2 grey--text fonte">
              {{ insumos.length }} encontrados
            </span>
            <template v-for="(insumo, index) in insumos">
              <v-list-item
                @click="abririnsumo(insumo, index)"
                style="border-radius: 6px;"
                :key="insumo._id"
                class="fonte pl-1 pr-1"
              >
                <v-list-item-content class="ml-2">
                  <v-list-item-title class="fonte fonteMini">
                    {{ insumo.nome }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="fonteMini">
                    <!-- chip acompanha o tema (no escuro ficava claro/ilegível) -->
                    <v-chip
                      x-small
                      :color="isDarkTheme ? '#202c33' : '#f0f0f0'"
                      :style="`color: ${isDarkTheme ? '#25d366' : $theme.primary}; border-radius: 3px;`"
                    >
                      {{ insumo.type }}
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-if="
                      insumo.unidade_estoque_minimo &&
                        insumo.ultimo_preco_de_compra &&
                        (insumo.type == 'Placa' || insumo.type == 'Material')
                    "
                    class="fonteMini"
                  >
                    {{ $helper.formataSaldo(insumo.ultimo_preco_de_compra) }}
                    por
                    {{ insumo.unidade_estoque_minimo.valor }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-avatar rounded color="#f2f2f2" size="36">
                    <v-img
                      v-if="insumo.imagens[0]"
                      :src="insumo.imagens[0]"
                      :alt="insumo.nome"
                      :lazy-src="insumo.imagem"
                    ></v-img>
                    <v-icon v-else :color="$theme.primary">
                      mdi-cog-outline
                    </v-icon>
                  </v-avatar>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="index"></v-divider>
            </template>
            <v-list-item
              style="min-height: 200px;"
              v-intersect="onIntersect"
            ></v-list-item>
          </v-list>
        </v-flex>
        <v-flex v-if="get_insumos.docs.length === 0" xs12>
          <div
            class="expande-horizontal pa-3 wrap centraliza"
            style="height: 36vh;"
          >
            <img style="width: 100px;" src="img/empty.gif" alt="empty" />
            <span class="px-3 fonte-subtitulo grey--text text-center">
              Não há produtos cadastrados ainda, clique no botão abaixo e
              cadastre um, os produtos são separados em 5 categorias.
            </span>
            <v-btn
              dark
              id="novo-insumo"
              class="mt-6 fonte black--text"
              :color="$theme.primary"
              @click="iniciarCadastro"
            >
              Novo
              <v-icon
                size="12"
                color="#333"
                class="ml-1 animate__animated"
                :class="getPersonalizedLoading"
                >mdi-plus</v-icon
              >
            </v-btn>
          </div>
        </v-flex>
      </v-flex>
      <v-flex v-if="$vuetify.breakpoint.lgAndUp" xs12 md9 lg9>
        <div
          v-if="get_insumo.new || get_insumo._id"
          class="expande-horizontal centraliza pt-1 wrap"
        >
          <!-- Header de cadastro de insumos -->
          <v-flex xs12>
            <div class="windows-style expande-horizontal fonte column">
              <transition name="slide-fade">
                <v-list-item class="pa-0 ma-0">
                  <v-avatar
                    @click="backToList"
                    style="cursor: pointer;"
                    size="27"
                    :color="$theme.primary"
                    class="mr-2"
                    icon
                  >
                    <v-icon color="#f2f2f2">mdi-close</v-icon>
                  </v-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">
                      {{ get_insumo.new ? "Novo item" : get_insumo.nome }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="font-mini">
                      Gerencie os detalhes do item
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </transition>
            </div>
          </v-flex>
          <div
            style="height: 73vh; overflow: auto;"
            class="windows-style-content pb-3 pt-0 expande-horizontal wrap"
          >
            <!-- Form de cadastro de insumos -->
            <v-flex xs12>
              <v-tabs
                v-model="tabs"
                centered
                dark
                class="fonte"
                :background-color="$theme.primary"
              >
                <v-tab>Info do Produto</v-tab>
                <v-tab v-if="get_insumo.type == 'Material'"
                  >Entrada e saída (estoque)</v-tab
                >
              </v-tabs>
              <InsumoWizard
                v-if="tabs == 0"
                @delete="excluir_insumo_dialog(get_insumo)"
                @saved="onWizardSaved"
                @type-selected="onWizardTypeSelected"
              />
            </v-flex>
            <!-- Gerência do estoque -->
            <v-flex v-if="get_insumo._id && tabs == 1" class="mt-6 mb-3" xs12>
              <div class="expande-horizontal fonte column">
                <v-flex class="mb-3 px-3" xs12>
                  <transition name="slide-fade">
                    <v-list-item
                      @click="iniciaCadastroEstoque"
                      class="pa-0 ma-0"
                    >
                      <v-avatar color="#47CF72" class="mr-2" icon>
                        <v-icon dark>mdi-cube-send</v-icon>
                      </v-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ get_insumo.new ? "Novo item" : get_insumo.nome }}
                        </v-list-item-title>
                        <v-list-item-subtitle class="font-mini">
                          {{ quantidadeEstoque.quantidade
                          }}{{
                            get_insumo && get_insumo.unidade_estoque_minimo
                              ? get_insumo.unidade_estoque_minimo.valor
                              : ""
                          }}
                          em estoque
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn
                          :color="$theme.third"
                          class="text-capitalize"
                          @click="iniciaCadastroEstoque"
                          small
                        >
                          <v-icon color="white" class="mr-1" size="15"
                            >mdi-plus-circle-outline</v-icon
                          >
                          <span class="white--text fonte fonte-mini"
                            >Add Estoque</span
                          >
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </transition>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-list color="transparent" dense class="pa-0 ma-0">
                    <template v-for="estoque in get_estoques.docs">
                      <v-list-item
                        style="border-radius: 5px; background: #f2f2f2;"
                        class="ma-0 mb-2 pa-0"
                        :key="estoque._id"
                      >
                        <v-avatar
                          class="mx-3"
                          color="green"
                          v-if="estoque.type === 'in' || !estoque.type"
                        >
                          <v-icon size="18" color="white">
                            mdi-arrow-up-circle-outline
                          </v-icon>
                        </v-avatar>
                        <v-avatar class="mx-3" color="red" v-else>
                          <v-icon size="18" class="ml-2 mr-2" color="white">
                            mdi-arrow-down-circle-outline
                          </v-icon>
                        </v-avatar>
                        <v-list-item-content
                          class="fonte-subtitulo fonte-italica font-weight-bold"
                        >
                          <v-list-item-title>
                            {{ estoque.quantidade }}
                            {{
                              estoque && estoque.unidade_de_medida
                                ? estoque.unidade_de_medida.valor
                                : ""
                            }}
                            de
                            {{ estoque.produto.nome }}
                          </v-list-item-title>
                          <v-list-item-subtitle v-if="estoque.type === 'in'">
                            Preço Base:
                            {{ $helper.formataSaldo(estoque.preco_de_compra) }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="estoque.type === 'in'">
                            Total comprado:
                            {{ sumValueBuyed(estoque) }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="fonte-micro"
                            >{{
                              $moment(estoque.created_at).format(
                                "DD/MM/YY [às] HH:mm"
                              )
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-flex>
              </div>
            </v-flex>
            <v-flex v-if="false" xs12 v-show="tabs === 2 && get_insumo._id && get_insumo.type == 'Forma Pronta'">
              <div class="expande-horizontal">
                <v-flex class="" xs12>
                  <div class="expande-horizontal wrap">
                    <v-flex xs12>
                      <v-window v-model="windowInsumo">
                        <v-window-item :value="1">
                          <div
                            class="expande-horizontal pa-6 white--text column gradient-insumos"
                          >
                            <div class="centraliza pb-3 expande-horizontal">
                              <v-icon>mdi-list-box-outline</v-icon>
                              <h3 class="fonte ml-1">
                                Ficha Técnica de produção
                              </h3>
                              <v-spacer></v-spacer>
                            </div>
                            <v-spacer></v-spacer>
                            <div class="expande-horizontal">
                              <h1 class="fonte">
                                {{
                                  $helper.formataSaldo(
                                    get_insumo.ultimo_preco_de_compra || 0
                                  )
                                }}
                              </h1>
                            </div>
                            <div class="expande-horizontal column">
                              <span class="fonte">
                                Este composto é composto por
                                {{
                                  get_insumo?.ficha_tecnica
                                    ? get_insumo.ficha_tecnica?.length
                                    : 0
                                }}
                                outros insumos, confira abaixo.
                              </span>
                              <div class="fonte mt-1 expande-horizontal">
                                <v-btn
                                  :color="$theme.secondary"
                                  dark
                                  class="font-weight-bold"
                                  @click="windowInsumo = 2"
                                >
                                  Adicionar insumo
                                  <v-icon right>
                                    mdi-chevron-right
                                  </v-icon>
                                </v-btn>
                              </div>
                            </div>
                          </div>
                        </v-window-item>
                        <v-window-item :value="2">
                          <div
                            class="expande-horizontal white--text column gradient-insumos-form"
                          >
                            <div
                              class="expande-horizontal centraliza px-3 py-6 wrap"
                            >
                              <div class="expande-horizontal">
                                <h3 class="fonte">
                                  Pesquise e selecione o insumo:
                                </h3>
                              </div>
                              <v-flex
                                xs12
                                v-if="
                                  insumos_ficha_tecnica_de_producao.docs.length >
                                    0 && insumos_ficha_tecnica_de_producao.docs
                                "
                              >
                                <v-list dark color="transparent" dense>
                                  <template
                                    v-for="(itemFicha,
                                    i) in insumos_ficha_tecnica_de_producao.docs"
                                  >
                                    <v-list-item
                                      class="item-list-insumo"
                                      @click="
                                        selecionaInsumoParaAdicionarAoProduto(
                                          itemFicha
                                        )
                                      "
                                      :key="i / 2"
                                    >
                                      <v-list-item-title>
                                        <span class="fonte">
                                          {{ itemFicha?.nome }}
                                        </span>
                                      </v-list-item-title>
                                      <v-list-item-action>
                                        <v-btn
                                          x-small
                                          text
                                          @click="
                                            selecionaInsumoParaAdicionarAoProduto(
                                              itemFicha
                                            )
                                          "
                                        >
                                          Adicionar
                                          <v-icon size="15" class="mr-2"
                                            >mdi-plus-circle</v-icon
                                          >
                                        </v-btn>
                                      </v-list-item-action>
                                    </v-list-item>
                                  </template>
                                </v-list>
                              </v-flex>
                              <div v-else>
                                <span class="fonte white--text text-center"
                                  >Sem resultados, faça uma busca abaixo</span
                                >
                              </div>
                            </div>
                            <v-card
                              light
                              flat
                              :color="$theme.primary"
                              class="expande-horizontal px-3 centraliza"
                            >
                              <v-flex class="pt-2 pr-2 pb-2">
                                <v-text-field
                                  v-model="filter_insumo_ficha_tecnica"
                                  append-icon="mdi-magnify"
                                  @click:append="
                                    list_insumos_ficha_tecnica_de_producao
                                  "
                                  @keyup.enter="
                                    list_insumos_ficha_tecnica_de_producao
                                  "
                                  hide-details
                                  solo
                                  flat
                                  dense
                                  placeholder="Pesquise o insumo aqui"
                                ></v-text-field>
                              </v-flex>
                              <!-- <Filtros style="color: #333" /> -->
                              <v-btn
                                color="red lighten-2"
                                class="fonte"
                                dark
                                small
                                @click="windowInsumo = 1"
                                >Cancelar</v-btn
                              >
                            </v-card>
                          </div>
                        </v-window-item>
                        <v-window-item :value="3">
                          <div
                            class="expande-horizontal pt-3 pb-3 white--text column gradient-insumos-form"
                          >
                            <div class="expande-horizontal column px-3">
                              <div class="expande-horizontal">
                                <h3 class="fonte">
                                  Informe a porção a adicionar:
                                </h3>
                              </div>
                              <v-flex xs12>
                                <v-list dark color="transparent" dense>
                                  <v-list-item class="item-list-insumo">
                                    <v-list-item-content>
                                      <v-list-item-title>
                                        <span class="fonte">
                                          {{ windowInsumoForm.nome }}
                                        </span>
                                      </v-list-item-title>
                                      <v-list-item-subtitle>
                                        <span class="fonte">
                                          Unidade:
                                          {{
                                            windowInsumoForm
                                              .unidade_estoque_minimo.nome
                                          }}
                                        </span>
                                      </v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-flex>
                              <v-flex xs12>
                                <v-form ref="formInsumo">
                                  <v-flex xs12>
                                    <v-text-field
                                      solo
                                      dense
                                      :rules="[v => !!v || 'Campo obrigatório']"
                                      ref="quantidadeField"
                                      v-mask="
                                        windowInsumoForm.unidade_estoque_minimo
                                          .nome === 'UNIDADE'
                                          ? ['#', '##', '###', '####']
                                          : ['#.##', '#.###', '##.##', '##.###']
                                      "
                                      @keyup.enter.prevent="
                                        finalizar_e_salvar_insumo
                                      "
                                      :prefix="
                                        `Quantidade em ${
                                          windowInsumoForm.unidade_estoque_minimo
                                            ? windowInsumoForm
                                                .unidade_estoque_minimo.nome
                                            : ''
                                        }: `
                                      "
                                      v-model="windowInsumoForm.quantidade"
                                    ></v-text-field>
                                  </v-flex>
                                </v-form>
                              </v-flex>
                            </div>
                            <div class="expande-horizontal centraliza">
                              <v-btn
                                x-small
                                dark
                                color="red lighten-2"
                                class="fonte mr-2"
                                @click="windowInsumo = 1"
                              >
                                <v-icon size="13" class="mr-1"
                                  >mdi-chevron-left</v-icon
                                >
                                Cancelar</v-btn
                              >
                              <v-btn
                                color="green"
                                dark
                                small
                                class="fonte"
                                @click="finalizar_e_salvar_insumo"
                                >Finalizar e adicionar
                                <v-icon>mdi-save</v-icon></v-btn
                              >
                            </div>
                          </div>
                        </v-window-item>
                      </v-window>
                    </v-flex>
                    <v-flex class="pl-1 pr-1" xs12>
                      <v-flex xs12>
                        <h5 class="fonte mt-3 grey--text">
                          Confira a ficha técnica abaixo:
                        </h5>
                      </v-flex>
                      <v-list
                        color="transparent"
                        dark
                        v-if="
                          get_insumo.ficha_tecnica &&
                            get_insumo.ficha_tecnica.length
                        "
                        dense
                      >
                        <template
                          v-for="(itemFicha, i) in get_insumo.ficha_tecnica"
                        >
                          <v-list-item
                            :style="
                              `border: 1px solid #e0e0e0; background: #f2f2f2; border-radius: 5px; margin-bottom: 6px;`
                            "
                            @click="() => {}"
                            :key="i / 2"
                          >
                            <v-list-item-content>
                              <v-list-item-title>
                                <span class="fonte">
                                  {{ itemFicha.quantidade }}
                                  {{ itemFicha | filterUnidade }} de
                                  {{ itemFicha.nome }}
                                </span>
                              </v-list-item-title>
                              <v-list-item-subtitle
                                class="light-green--text fonte fonte-bold"
                              >
                                + {{ itemFicha | calcGramaTotal }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                              <v-btn
                                icon
                                @click="removerInsumo(false, itemFicha, i)"
                              >
                                <v-icon color="red">mdi-minus</v-icon>
                              </v-btn>
                            </v-list-item-action>
                          </v-list-item>
                        </template>
                      </v-list>
                      <div v-else class="expande-horizontal centraliza">
                        <span class="fonte grey--text pa-6 text-center">
                          Este insumo ainda não possui ficha técnica de produção,
                          adicione acima.
                        </span>
                      </div>
                    </v-flex>
                  </div>
                </v-flex>
              </div>
            </v-flex>
          </div>
        </div>
      </v-flex>
      <v-dialog
        v-else
        transition="slide-x-transition"
        fullscreen
        :value="get_insumo._id || get_insumo.new ? true : false"
      >
        <v-card class="pl-3">
          <div
            v-if="get_insumo.new || get_insumo._id"
            class="expande-horizontal centraliza wrap"
          >
            <!-- Header de cadastro de insumos -->
            <v-flex class="mb-2" xs12>
              <div class="expande-horizontal fonte column">
                <transition name="slide-fade">
                  <v-list-item class="pa-0 ma-0">
                    <v-btn @click="backToList" class="mr-2" icon>
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-bold">
                        {{ get_insumo.new ? "Novo item" : get_insumo.nome }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="font-mini">
                        Gerencie os detalhes do item
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </transition>
              </div>
            </v-flex>
            <div
              style="height: 86vh; overflow: auto;"
              class="windows-style-content pb-3 pt-0 expande-horizontal wrap"
            >
              <!-- Form de cadastro de insumos -->
              <v-flex xs12>
                <v-tabs
                  v-model="tabs"
                  centered
                  dark
                  class="fonte"
                  :background-color="$theme.primary"
                >
                  <v-tab>Info do Produto</v-tab>
                  <v-tab v-if="get_insumo.type == 'Material'"
                    >Entrada e saída (estoque)</v-tab
                  >
                </v-tabs>
                <InsumoWizard
                  v-if="tabs == 0"
                  @delete="excluir_insumo_dialog(get_insumo)"
                  @saved="onWizardSaved"
                  @type-selected="onWizardTypeSelected"
                />
              </v-flex>
              <!-- Gerência do estoque -->
              <v-flex v-if="get_insumo._id && tabs == 1" class="mt-6 mb-3" xs12>
                <div class="expande-horizontal fonte column">
                  <v-flex class="mb-3 px-3" xs12>
                    <transition name="slide-fade">
                      <v-list-item
                        @click="iniciaCadastroEstoque"
                        class="pa-0 ma-0"
                      >
                        <v-avatar color="#47CF72" class="mr-2" icon>
                          <v-icon dark>mdi-cube-send</v-icon>
                        </v-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-bold">
                            {{ get_insumo.new ? "Novo item" : get_insumo.nome }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="font-mini">
                            {{ quantidadeEstoque.quantidade
                            }}{{
                              get_insumo && get_insumo.unidade_estoque_minimo
                                ? get_insumo.unidade_estoque_minimo.valor
                                : ""
                            }}
                            em estoque
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            :color="$theme.third"
                            class="text-capitalize"
                            @click="iniciaCadastroEstoque"
                            small
                          >
                            <v-icon color="white" class="mr-1" size="15"
                              >mdi-plus-circle-outline</v-icon
                            >
                            <span class="white--text fonte fonte-mini"
                              >Add Estoque</span
                            >
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </transition>
                  </v-flex>
                  <v-flex xs12 class="px-3">
                    <v-list color="transparent" dense class="pa-0 ma-0">
                      <template v-for="estoque in get_estoques.docs">
                        <v-list-item
                          style="border-radius: 5px; background: #f2f2f2;"
                          class="ma-0 mb-2 pa-0"
                          :key="estoque._id"
                        >
                          <v-avatar
                            class="mx-3"
                            color="green"
                            v-if="estoque.type === 'in' || !estoque.type"
                          >
                            <v-icon size="18" color="white">
                              mdi-arrow-up-circle-outline
                            </v-icon>
                          </v-avatar>
                          <v-avatar class="mx-3" color="red" v-else>
                            <v-icon size="18" class="ml-2 mr-2" color="white">
                              mdi-arrow-down-circle-outline
                            </v-icon>
                          </v-avatar>
                          <v-list-item-content
                            class="fonte-subtitulo fonte-italica font-weight-bold"
                          >
                            <v-list-item-title>
                              {{ estoque.quantidade }}
                              {{
                                estoque && estoque.unidade_de_medida
                                  ? estoque.unidade_de_medida.valor
                                  : ""
                              }}
                              de
                              {{ estoque.produto.nome }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="estoque.type === 'in'">
                              Preço Base:
                              {{
                                $helper.formataSaldo(estoque.preco_de_compra)
                              }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle v-if="estoque.type === 'in'">
                              Total comprado:
                              {{ sumValueBuyed(estoque) }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="fonte-micro"
                              >{{
                                $moment(estoque.created_at).format(
                                  "DD/MM/YY [às] HH:mm"
                                )
                              }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-flex>
                </div>
              </v-flex>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-sheet>
    <CreateStock :materials="[]" ref="createStock" />
  </layout>
</template>

<script>
import { driver } from "driver.js";
import Filtros from "../components/Filtros.vue";
import VisualizacaoEmCard from "../components/VisualizacaoEmCard.vue";
import VisualizacaoEmLista from "../components/VisualizacaoEmLista.vue";
import Paginacao from "../components/Paginacao.vue";
import ListagemVazia from "../components/ListagemVazia.vue";
import ModalView from "../components/modalView.vue";
import { mapActions, mapGetters } from "vuex";
import ModalSendArchive from "../../shared/components/ModalSendArchive.vue";
import ModalSendArchiveById from "../../shared/components/ModalSendById.vue";
import CreateStock from "@/apps/Insumos/components/ModalCreateStock.vue";
import InsumoWizard from "@/apps/Insumos/components/InsumoWizard.vue";

export default {
  data() {
    return {
      tabs: 0,
      card: false,
      contextDialog: false,
      drawer: false,
      formEstoqueDialog: false,
      filter: {
        search: "",
        type: ""
      },
      insumos_ficha_tecnica_de_producao: {
        docs: []
      },
      options: [
        {
          nome: "Novo item",
          action: this.iniciarCadastro,
          id: "btn-cadastro-insumo",
          icon: "mdi-plus"
        },
        {
          icon: "mdi-information",
          nome: "Iniciar Guia",
          action: () => this.driverStart()
        },
        // {
        //   nome: "Estoque",
        //   action: this.iniciaCadastroEstoque,
        //   icon: "mdi-plus"
        // }
      ],
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        },
        {
          name: "Produtos",
          path: "/insumos"
        }
      ],
      get_categoria: {
        insumos: []
      },
      nova_secao: "",
      formPrecoMultiplo: {},
      unidades_de_medida: [
        {
          nome: "Kilo(KG)",
          valor: "KG",
          divisor: 1000
        },
        {
          nome: "GRAMA(g)",
          valor: "g",
          divisor: 1
        },
        {
          nome: "Litro (L)",
          valor: "L",
          divisor: 1000
        },
        {
          nome: "Mililitro (ML)",
          valor: "ML",
          divisor: 1000
        },
        {
          nome: "UNIDADE",
          valor: "UN",
          divisor: 1
        },
        {
          nome: "CAIXA",
          valor: "CX",
          divisor: 1
        }
      ],
      unidades_de_medida_base: [
        {
          nome: "Kilo(KG)",
          valor: "KG",
          divisor: 1000
        },
        {
          nome: "Litro (L)",
          valor: "L",
          divisor: 1000
        },
        {
          nome: "UNIDADE",
          valor: "UN",
          divisor: 1
        },
        {
          nome: "Metro Quadrado",
          valor: "M2",
          divisor: 100
        }
        // {
        //   nome: "CAIXA",
        //   valor: "CX"
        // },
        // {
        //   nome: "PACOTE",
        //   valor: "PCT",
        //   divisor: 1
        // }
      ],
      itemsToShow: 10,
      forma_pronta_form: {
        quantidade: 1,
        insumo: null,
        comprimento: "",
        largura: ""
      },
      driver: null
    };
  },
  filters: {
    precoDeEntrada(val) {
      const quantidade = parseFloat(val.quantidade);
      const preco_de_compra = parseFloat(val.preco_de_compra);
      const preco_por_divisor = preco_de_compra / val.divisor;
      const total_de_entrada = quantidade * preco_por_divisor;
      return total_de_entrada;
    }
  },
  components: {
    Filtros,
    VisualizacaoEmCard,
    VisualizacaoEmLista,
    Paginacao,
    ListagemVazia,
    ModalView,
    ModalSendArchive,
    ModalSendArchiveById,
    CreateStock,
    InsumoWizard
  },
  computed: {
    ...mapGetters([
      "get_estoque",
      "get_estoques",
      "get_insumos_filtros",
      "get_estoques_filtros",
      "getLoggedUser",
      "get_insumo",
      "get_insumos",
      "getLinksById",
      "getPersonalizedLoading"
    ]),
    // condição oficial de tema escuro do sistema
    isDarkTheme() {
      return localStorage.dark === "true";
    },
    insumos() {
      if (this.filter.search || this.filter.type) {
        console.log("caiu 1u");
        const filter = {
          search: this.filter.search || "",
          type: this.filter.type || ""
        };
        const filtereds = this.get_insumos.docs.filter(insumo => {
          const affirmation1 =
            insumo.nome.toLowerCase().indexOf(filter.search.toLowerCase()) !==
            -1;
          const affirmation2 =
            filter.type && insumo.type && insumo.type == filter.type;
          return affirmation1 && affirmation2;
        });
        return filtereds;
      } else {
        const insumos = this.get_insumos.docs;
        return insumos.slice(0, this.itemsToShow);
      }
    },
    // peças desenháveis do template da Forma Pronta (preview visual)
    // ===== cadastro de FURO (recorte do desenho técnico) =====
    // preview do símbolo padrão (mesmo render do desenho técnico)
    quantidadeEstoque() {
      const calcPreco = val => {
        const quantidade = parseFloat(val.quantidade);
        const preco_de_compra = parseFloat(
          val.preco_de_compra ? val.preco_de_compra : 0
        );
        const preco_por_divisor =
          preco_de_compra /
          (val.unidade_de_medida.divisor ? val.unidade_de_medida.divisor : 0);
        const total_de_entrada = quantidade * (preco_por_divisor || 0);
        return total_de_entrada;
      };
      let totalEstoque = {
        quantidade: 0,
        valor_total: 0
      };
      if (this.get_estoques.docs) {
        this.get_estoques.docs.map(estoque => {
          try {
            const type = estoque.type || "in";
            if (type === "in") {
              totalEstoque.quantidade += estoque.quantidade;
              totalEstoque.valor_total += calcPreco(estoque);
            }
            if (type === "out") {
              totalEstoque.quantidade -= estoque.quantidade;
              totalEstoque.valor_total -= calcPreco(estoque);
            }
          } catch (err) {
            console.log("33333333 e", err);
          }
        });
      }

      totalEstoque.quantidade = totalEstoque.quantidade.toFixed(2);
      return totalEstoque;
    }
  },
  mounted() {
    this.mountDriver();
    this.verifyGuideState();
  },
  methods: {
    reset_forma_pronta_form() {
      this.forma_pronta_form = {
        quantidade: 1,
        insumo: null,
        comprimento: "",
        largura: ""
      };
    },
    // atualiza a configuração do Furo (símbolo/medidas em cm)
    // popula o template com uma bancada pronta (reta, L ou U) já com
    // silhueta, posição e acabamento de frente — o marmorista só ajusta
    selecionaInsumoParaAdicionarAoProduto(item) {
      this.windowInsumoForm = item;
      this.windowInsumo = 3;
      setTimeout(() => {
        this.$refs.quantidadeField.focus();
      }, 200);
    },
    list_insumos_ficha_tecnica_de_producao() {
      this.loading = "insumos_ficha_tecnica";
      this.$run("insumos/list", {
        nome: this.filter_insumo_ficha_tecnica
      }).then(res => {
        this.loading = "";
        this.insumos_ficha_tecnica_de_producao = res.data;
      });
    },
    mountDriver() {
      this.driver = driver({
        showProgress: true,
        allowClose: true,
        steps: [
          // {
          //   element: "#Produtos",
          //   popover: {
          //     title: "Primeira coisa a se fazer",
          //     description:
          //       "Antes de criar um orçamento, você precisa cadastrar os tipos de produtos que você faz, pra isso, clique no menu 'Produtos'",
          //     showButtons: ["next"],
          //     nextBtnText: "Avançar"
          //   }
          // },
          {
            element: "#options-container",
            popover: {
              title: "Tipo de itens",
              description:
                "Clique em 'Novo item', vamos criar uma placa, uma peça principal e 1 acabamento. Esta é a base para um bom orçamento!.",
              // showButtons: [],
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          // {
          //   element: "#nova-info-geral",
          //   popover: {
          //     title: "1º item - Placa",
          //     description:
          //       "Aqui você pode criar qualquer tipo de item, escolha o tipo Placa primeiro.",
          //   }
          // },
          {
            element: "#Tipo-Placa",
            popover: {
              title: "1º item - Placa",
              description:
                "Aqui você pode criar qualquer tipo de item, escolha o tipo Placa primeiro.",
              // showButtons: []
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
              //   nextBtnText: "Avançar",
              // prevBtnText: "Voltar"
            }
          },
          {
            element: "#novo-registro-info",
            popover: {
              title: "Informações",
              description:
                "Digite o nome da placa, por exemplo: Cinza Corumbá e o preço por metro quadrado que você cobra.",
              // showButtons: ['next'],
              // nextBtnText: "Avançar",
              // prevBtnText: "Voltar"
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#salvar-btn",
            popover: {
              title: "Salvar a placa",
              description: "Clique em salvar.",
              // nextBtnText: "Avançar",
              // showButtons: ['previous'],
              // prevBtnText: "Voltar",
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          //fim da criação da primeira placa

          // inicio da criação da primeira peça principal
          {
            element: "#options-container",
            popover: {
              title: "Primeira placa criada!",
              description:
                "Agora vamos criar uma peça principal, clique em 'Novo item'.",
              // showButtons: [],
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#Tipo-Peça-Principal",
            popover: {
              title: "",
              description: "Escolha o tipo Peça Principal agora.",
              // showButtons: [],
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
              // nextBtnText: "Avançar",
              // prevBtnText: "Voltar"
            }
          },
          {
            element: "#novo-registro-info",
            popover: {
              title: "Crie com o nome 'Rodapé'",
              description:
                "Uma Peça Principal é aquela que é a parte principal de uma peça completa, ex: 'Balcão Americano'.",
              // showButtons: ['next'],
              // nextBtnText: "Avançar",
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#salvar-btn",
            popover: {
              title: "Salve seu Rodapé",
              description: "Clique em salvar.",
              // closeBtnText: "Fechar",
              // showButtons: ['previous'],
              // prevBtnText: "Voltar"
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#no",
            popover: {
              title: "Muito bom, um detalhe",
              description:
                "Você pode criar peças secundárias também, uma saia que é um caimento da peça principal por exemplo, uma peça secundária é aquela que se liga a uma peça principal.",
              // closeBtnText: "Fechar",
              // showButtons: ['next'],
              // nextBtnText: "Entendi",
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          // fim da criação da primera peça principal

          // inicio da criação do primeiro acabamento
          {
            element: "#options-container",
            popover: {
              title: "Por último, vamos criar o seu primeiro Tipo Acabamento",
              description: "Clique em 'Novo item'.",
              // showButtons: []
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#Tipo-Acabamento",
            popover: {
              title: "",
              description: "Escolha o tipo Acabamento.",
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#novo-registro-info",
            popover: {
              title: "Crie um Acabamento Chamado 'Boleado'",
              description:
                "Um Acabamento é um procedimento que será realizado na peça principal, outro exemplo: Furo de Torneira de 40mm.",
              // showButtons: ['next'],
              // nextBtnText: "Avançar",
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#salvar-btn",
            popover: {
              title: "Salve seu acabamento",
              description: "Clique em salvar.",
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          },
          {
            element: "#no",
            popover: {
              title: "Parabéns 🎓",
              description:
                "Está tudo pronto para começar a criar seus Orçamentos.",
              // closeBtnText: "Fechar",
              nextBtnText: "Vamos lá 🚀",
              prevBtnText: ""
            }
          },
          {
            element: '#menu-Caixa',
            popover: {
              title: "Parabéns 🎓",
              description:
                "Está tudo pronto para começar a criar seus Orçamentos, acesse o menu de Atendimento aqui.",
              // showButtons: [],
              closeBtnText: "Fechar",
              prevBtnText: "Voltar",
              nextBtnText: "Próximo"
            }
          }
        ]
        // onNextClick: () => {
        //   this.initActiveNextStep();
        // }
      });
    },
    driverStart() {
      this.driver.drive();
      this.initActiveNextStep(this);
    },
    nextStep() {
      console.log("executado");
      const self = this;
      self.driver.moveNext();
      // setTimeout(() => {
      // }, 200);
    },
    verifyGuideState() {
      if (localStorage.guide == "want") {
        const self = this;
        this.driverStart();
        setTimeout(() => {
          self.initActiveNextStep(self);
        }, 300);
      }
    },
    initActiveNextStep(self) {
      document
        .querySelector(".active-next-step")
        .removeEventListener("click", self.nextStep);
      // setTimeout(() => {
      document
        .querySelector(".active-next-step")
        .addEventListener("click", self.nextStep);
      // }, 500);
    },
    updateList() {
      this.$forceUpdate();
    },
    changeProductType(productType) {
      let unidade_de_medida;
      if (productType === "Placa") {
        unidade_de_medida = {
          nome: "Metro Quadrado",
          valor: "M2",
          divisor: 100
        };
      }
      if (productType === "Acabamento") {
        unidade_de_medida = {
          nome: "UNIDADE",
          valor: "UN",
          divisor: 1
        };
      }
      if (productType === "Forma Pronta") {
        unidade_de_medida = {
          nome: "Metro Quadrado",
          valor: "M2",
          divisor: 100
        };
      }
      if (productType === "Peça Principal") {
        unidade_de_medida = {
          nome: "Metro Quadrado",
          valor: "M2",
          divisor: 100
        };
      }
      if (productType === "Peça Secundária") {
        unidade_de_medida = {
          nome: "Metro Quadrado",
          valor: "M2",
          divisor: 100
        };
      }
      if (productType === "Furo") {
        unidade_de_medida = {
          nome: "UNIDADE",
          valor: "UN",
          divisor: 1
        };
      }

      const self = this;
      setTimeout(() => {
        self.nextStep();
      }, 300);
      if (productType === "Forma Pronta" && !this.get_insumo.ficha_tecnica) {
        this.$set(this.get_insumo, "ficha_tecnica", []);
      }
      if (productType !== "Forma Pronta") {
        this.reset_forma_pronta_form();
      }
      // Furo: garante a configuração default do recorte (símbolo + medidas)
      if (productType === "Furo" && !this.get_insumo.furo_config) {
        this.$set(this.get_insumo, "furo_config", {
          kind: "hole",
          diametro_cm: 10,
          largura_cm: 50,
          altura_cm: 40
        });
      }

      this.$store.commit("set_insumo", {
        ...this.get_insumo,
        type: productType,
        unidade_estoque_minimo: unidade_de_medida,
        disponivel: true,
        ...(productType === "Peça Secundária"
          ? {
              relacao_principal:
                this.get_insumo.relacao_principal ||
                this.get_insumo.relacaoPrincipal ||
                "neutra",
              relacaoPrincipal:
                this.get_insumo.relacaoPrincipal ||
                this.get_insumo.relacao_principal ||
                "neutra"
            }
          : {})
      });
    },
    onIntersect() {
      this.itemsToShow += 12;
    },
    excluir_insumo_dialog(item) {
      let text = "Deseja remover este insumo?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_insumo",
        action_value: item
      });
    },
    excluir_estoque_dialog(item) {
      let text = "Deseja remover registro do estoque?";
      this.createConfirmAction({
        message: text,
        icon: "mdi-close-circle",
        action: "excluir_estoque",
        action_value: item
      });
    },
    backToList() {
      this.$store.commit("set_insumo", {});
      this.reset_forma_pronta_form();
      this.$forceUpdate();
    },
    sumValueBuyed(val) {
      let qtd = val.quantidade || 0;
      let priceBuy = val.preco_de_compra || 0;
      let sum = qtd * priceBuy;
      return this.$helper.formataSaldo(sum);
    },
    forceUpdate() {
      this.$forceUpdate();
    },
    iniciaCadastroEstoque() {
      this.$refs.createStock.open("stock_up", this.get_insumo);
      this.get_estoque.unidade_de_medida = this.get_insumo.unidade_estoque_minimo;
    },
    abririnsumo(insumo) {
      this.$store.commit("set_insumo", insumo);
      this.reset_forma_pronta_form();
      this.$store.commit("setLinks", insumo.imagens);
      this.get_estoques_filtros.produto = insumo;
      this.listar_estoques();
    },
    removePrecoMultiplo(index) {
      let novoPrecoMultiplo = this.get_insumo.preco_multiplo.filter(
        (p, i) => i !== index
      );
      this.get_insumo.preco_multiplo = novoPrecoMultiplo;
    },
    getLinkById(id) {
      return this.getLinkById[id];
    },
    closeContextDialog() {
      this.contextDialog = false;
      setTimeout(() => {
        this.drawer = true;
      }, 10);
    },
    poc(text) {
      console.log(text);
    },
    ...mapActions([
      "abre_modal_view_tenant",
      "listar_tenants",
      "listar_insumos",
      "criar_estoque",
      "listar_insumocategorias",
      "criar_insumo",
      "listar_estoques",
      "atualizar_insumo",
      "setPersonalizedLoading",
      "createGlobalMessage",
      "createConfirmAction"
    ]),
    adicionarNovoPreco() {
      if (this.$refs.formNewPrecoMultiplo.validate()) {
        const preco = this.formPrecoMultiplo;
        this.get_insumo.preco_multiplo.push(preco);
        this.formPrecoMultiplo = {};
      }
    },
    adicionarEstoque() {
      if (this.$refs.formEstoque.validate()) {
        this.get_estoque.produto = this.get_insumo;
        this.get_estoque.origem = "insumo";
        this.criar_estoque();
        this.formEstoqueDialog = false;
      }
    },
    imprimir() {
      this.card = false;
      this.$refs.html2Pdf.generatePdf();
    },
    iniciarCadastro() {
      this.setPersonalizedLoading("animate__fadeOutTopRight");
      this.$store.commit("set_insumo", {
        new: true,
        preco_multiplo: []
      });
      this.reset_forma_pronta_form();
      this.$store.commit("setLinks", []);
      this.setPersonalizedLoading("animate__fadeInUp");
      this.$store.commit("set_estoques", {
        docs: [],
        page: 1,
        totalPages: 1
      });
    },
    // handlers do InsumoWizard (cadastro em passos): mantêm o tour (driver)
    // avançando como no fluxo antigo
    onWizardSaved() {
      const self = this;
      setTimeout(() => {
        if (self.driver) self.driver.moveNext();
      }, 600);
    },
    onWizardTypeSelected() {
      const self = this;
      setTimeout(() => {
        if (self.nextStep) self.nextStep();
      }, 300);
    }
  },
  created() {
    this.get_insumos_filtros.limitPerPage = 7;
    this.get_insumos_filtros.lista_de_compra = false;
    this.listar_insumos();
  }
};
</script>

<style scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
.item-list {
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #1173ff;
}
.product-type-container {
  display: flex;
  padding: 6px;
  background: #c1c1c1;
  border-radius: 6px;
}
</style>
